import React from 'react';
import { Stack } from 'react-bootstrap';
import SocialPostDetail from 'components/SocialPostDetail';
import '../styles.scss';

const PostDetail: React.FC = () => {
	return (
		<div className="social-feed">
			<div className="social-feed-left">
				<Stack className="social-feed-posts">
					<SocialPostDetail />
				</Stack>
			</div>
		</div>
	);
};

export default PostDetail;
